import { get, patch, httpDelete } from "@app/common/api";
import type {
  EventGroupACLDeleteRequest,
  EventGroupACLPatchRequest,
  EventGroupACLResponse,
} from "@app/common/types";
import { withQueryParamsUrl } from "@app/common/utils";

export const getEventGroupACL = async (
  id: string
): Promise<EventGroupACLResponse> => {
  return get(`/user-event-groups/${id}/acl`, { withCreds: true });
};

export const patchEventGroupACL = async (
  id: string,
  body: EventGroupACLPatchRequest
): Promise<void> => {
  return patch(`/user-event-groups/${id}/acl`, body, { withCreds: true });
};

export const deleteEventGroupACL = async (
  id: string,
  body: EventGroupACLDeleteRequest
): Promise<void> => {
  const params = {
    event_group_id: id,
    entity_id: body.entityId,
    entity_kind: body.kind,
    ...(body.applyToRecurringEvent && {
      apply_to_recurring_event: body.applyToRecurringEvent,
    }),
  };

  return httpDelete(
    withQueryParamsUrl(`/user-event-groups/${id}/acl`, params),
    { withCreds: true }
  );
};
